export enum CampaignsTabsEnum {
  CAMPAIGNS = "campaigns",
  PROJECTS = "projects",
  TASKS = "tasks"
}

export interface ICampaignsRule {
  campaignId?: string;
  id?: string;
  title: string;
  description: string;
}

export interface ICampaign {
  id: string;
  title: string;
  banner_url: string;
  secondary_banner_url: string;
  is_active: boolean;
  start_date: Date;
  end_date: Date;
  projects: IProject[];
  campaign_rules?: ICampaignsRule[];
  discord_role_id?: string;
  rewards: string[];
}

export interface IProject {
  id: string;
  title: string;
  project_url: string;
  twitter_handle: string;
  x_url: string;
  campaignId: string;
}

export interface IPaginationMeta {
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  totalPages: number;
}

export type TDAppsResponse = {
  meta: IPaginationMeta;
};

export enum ETaskType {
  FOLLOW = "follow",
  REPOST = "repost",
  VISIT = "visit",
  JOIN_DS_CHANNEL = "join_channel",
}

export interface ITask {
  id?: string;
  type: ETaskType | null;
  title: string;
  order: number;
  project: IProject;
  source?: string;
  guild_id?: string;
  role_id?: string;
  channel_link?: string;
}

export interface ITaskResponse {
  data: ITask[];
  total: number;
}

export interface ICampaignsResponse {
  data: ICampaign[];
  limit: number;
  page: number;
  total: number;
}

export interface IProjectsResponse {
  data: IProject[];
  limit: number;
  page: number;
  total: number;
}

export interface ITaskForm {
  id?: string;
  type: ETaskType | null;
  title: string;
  order: number;
  source: string;
  projectId: string;
  guildId: string;
  roleId: string;
  channelLink: string;
}
